<template>
   
  <v-container fluid>
    <v-card :elevation="0">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-card class="ma-4">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :footer-props="{
            'items-per-page-text': 'Emails por página'
          }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-row>
              <v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      right
                      @click="abrirDialogoEdit(item)"
                      color="blue"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>Editar Email</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      right
                      @click="abrirDialogoDelete(item)"
                      color="red"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>Eliminar Email</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialogCreate = true" fab dark bottom color="blue" left>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- Confirmación Eliminar -->
      <dialogo-confirmacion
        :activar="dialogDelete"
        tituloDialogo="ELIMINAR EMAIL"
        toolbarColor="red"
        :textoDialogo="`Seguro que quieres eliminar el email '${selectedItem.email}'?`"
        buttonColor="red"
        nombreMetodo="eliminar"
        @eliminar="eliminarEmailSeleccionado"
        @cancelar="dialogDelete = false"
      ></dialogo-confirmacion>

      <!-- Diálogo Editar Email -->
      <v-dialog v-model="dialogEdit" max-width="500px">
        <v-card elevation="2">
          <v-card-title>
            <span class="headline">Editar Email</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="edit_form">
              <v-col>
                <v-text-field
                  v-model="selectedItem.email"
                  label="Email"
                  :rules="[rules.required, rules.email]"
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="selectedItem.descripcion"
                  label="Descripción"
                ></v-text-field>
              </v-col>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialogEdit = false">Cancelar</v-btn>
            <v-btn color="blue" text @click="guardarEdicionEmail">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Crear Email -->
      <v-dialog v-model="dialogCreate" max-width="500px">
        <v-card elevation="2">
          <v-card-title>
            <span class="headline">Crear Email</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="create_form">
              <v-col>
                <v-text-field
                  v-model="newEmail.email"
                  label="Email"
                  :rules="[rules.required, rules.email]"
                  required
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="newEmail.descripcion"
                  label="Descripción"
                ></v-text-field>
              </v-col>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialogCreate = false">Cancelar</v-btn>
            <v-btn color="blue" text @click="guardarNuevoEmail">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
     <!-- Snackbar de errores -->
    <v-snackbar v-model="snackbar" :timeout="3000" top right color="red" elevation="2">
    {{ snackbarMessage }}
    <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
    </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import DialogoConfirmacion from "@/components/modulos/DialogoConfirmacion.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { DialogoConfirmacion },
  data() {
    return {
        snackbar: false,
        snackbarMessage: '',
      search: null,
      headers: [
        { text: "Email", value: "email" },
        { text: "Descripción", value: "descripcion" },
        { text: "Acciones", value: "acciones" },
      ],
      dialogCreate: false,
      dialogEdit: false,
      dialogDelete: false,
      selectedItem: {},
      newEmail: { email: "", descripcion: "" },
      items: [],
      rules: {
        required: (v) => !!v || "Campo requerido",
        email: (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Email inválido",
      },
    };
  },
  computed: {
    ...mapGetters("api", ["getIsAdmin"]),
  },
  mounted() {
    this.obtenerEmails();
  },
  methods: {
    ...mapActions("api", ["getEmails", "postEmail", "updateEmail", "deleteEmail"]),

    async obtenerEmails() {
      try {
        const res = await this.getEmails();
        this.items = res && res.data ? res.data : [];
      } catch (error) {
        console.error("Error al obtener emails:", error);
        this.items = [];
      }
    },

    abrirDialogoEdit(item) {
      this.selectedItem = { ...item };
      this.dialogEdit = true;
    },
    abrirDialogoDelete(item) {
      this.selectedItem = { ...item };
      this.dialogDelete = true;
    },

    async guardarNuevoEmail() {
        if (this.$refs.create_form && this.$refs.create_form.validate()) {
            try {
                await this.postEmail(this.newEmail);
                await this.obtenerEmails();
                this.dialogCreate = false;
                this.newEmail = { email: "", descripcion: "" };
            } catch (err) {
                const mensaje = err.response?.data?.msg || 'Error al crear email';
                this.snackbarMessage = mensaje;
                this.snackbar = true;
                console.warn("HA HABIDO UN ERROR EN AXIOS:", mensaje);
            }

        }
    },

    async guardarEdicionEmail() {
      await this.$nextTick();
      if (this.$refs.edit_form && this.$refs.edit_form.validate()) {
        try {
          await this.updateEmail(this.selectedItem);
          await this.obtenerEmails();
          this.dialogEdit = false;
        } catch (err) {
          console.error("Error al editar email:", err);
        }
      }
    },

    async eliminarEmailSeleccionado() {
      try {
        await this.deleteEmail(this.selectedItem.id);
        await this.obtenerEmails();
        this.dialogDelete = false;
      } catch (err) {
        console.error("Error al eliminar email:", err);
      }
    },
  },
};
</script>

<style>
.chips {
  width: 100px;
}
</style>
